import { render, staticRenderFns } from "./vb-gerente-devoluciones.vue?vue&type=template&id=5c1fe4ca&scoped=true&"
import script from "./vb-gerente-devoluciones.vue?vue&type=script&lang=js&"
export * from "./vb-gerente-devoluciones.vue?vue&type=script&lang=js&"
import style0 from "./vb-gerente-devoluciones.vue?vue&type=style&index=0&id=5c1fe4ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1fe4ca",
  null
  
)

export default component.exports